/**
 * sessionStorage 汎用アクセスサービス
 * JSON parse 失敗時は安全に fallback する
 */

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {

  /** JSON値を取得（parse失敗時は fallback を返す） */
  getItem<T>(key: string, fallback: T | null = null): T | null {
    try {
      const raw = sessionStorage.getItem(key);
      if (raw === null) return fallback;
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  }

  /** JSON値を保存 */
  setItem<T>(key: string, value: T): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // 容量超過等は無視
    }
  }

  /** キーを削除 */
  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // 無視
    }
  }
}
